import React from "react";
import {
  PayoutHeader,
  PayoutHeaderItem,
  PayoutSeparator
} from "../styled-components";

export interface PayoutsHeaderProps {
  titles: string[];
  isCanceled: boolean;
  isDesktop: boolean;
}

const PayoutsHeaderComp = ({
  titles,
  isCanceled,
  isDesktop
}: PayoutsHeaderProps) => {
  if (titles.length > 1 && !isCanceled) {
    return (
      <>
        <PayoutHeader cols={titles.length} isDesktop={isDesktop}>
          {titles.map((title, index) => (
            <PayoutHeaderItem
              key={index.toString()}
              hasTwoColumns={titles.length === 2}
            >
              {title}
            </PayoutHeaderItem>
          ))}
        </PayoutHeader>
        <PayoutSeparator />
      </>
    );
  }

  return null;
};

export default PayoutsHeaderComp;
